<template>
  <div class="info-tooltip">
    <i-icon
      :id="tooltipId"
      :class="iconClass"
      class="info-icon"
      :symbol="symbol"
      :size="16"
    ></i-icon>
    <i-tooltip
      :target="`#${tooltipId}`"
      :title="title"
      :description="subtitle"
      :alignment="placement"
    />
  </div>
</template>

<script>
import { iIcon, iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';

export default {
  name: 'InfoTooltip',
  components: {
    iIcon,
    iTooltip,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    container: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: iTooltipAlignmentMode.TOP_MIDDLE,
    },
    iconClass: {
      type: String,
      default: 'i-text-neutral-110',
    },
    symbol: {
      type: String,
      default: 'small-info-circle',
    },
  },
  data() {
    return {
      tooltipId: `info-tooltip-${this._uid}`,
    };
  },
};
</script>

<style lang="scss">
.tooltip {
  .tooltip-inner {
    max-width: 320px;
    text-align: left;
    padding: 12px;
    transition: none;
  }
}
</style>

<style lang="scss" scoped>
.info-tooltip {
  .info-icon {
    cursor: pointer;
  }
}
</style>
